export default `
Download configuration package that can be used with [Strongswan](${process.env.REACT_APP_KB_URL}/l/strongswan) or [Acreto vGateway Installer](${process.env.REACT_APP_KB_URL}/l/gateway-installer) to connect to your ecosystem.\n\n
[Click here](${process.env.REACT_APP_KB_URL}/l/ipsec-overview) for more details.
`;
